import { CourseMaster } from './CourseMaster.model';
import { DocumentMaster } from './DocumentMaster.model';
import { EnrollCourseMaster } from './EnrollCourseMaster.model';
import { OfferMaster } from './OfferMaster.model';
import { StudentMaster } from './StudentMaster.model';

export class ReceiptMaster{
    public receiptMasterId:number;
    // public enrollCourseMaster:EnrollCourseMaster;
    public receiptNo:String;
    public studentMaster:StudentMaster;
    // public paymentTransaction:PaymentTransaction;
    public amount:number;
    public receiptMonthTemp:string;
    public paidDate:Date;
    public defaultSelected:Boolean;
    public offer:OfferMaster;
    public receiptFilePath:string;
    public courseMasterList: CourseMaster[]=[];
    public pageNumber:number;
    public pageSize:number;
    public receiptThumbnailImage:DocumentMaster;
}